import { createSelector } from '@reduxjs/toolkit';
import {
  getIsAppleMobile,
  getIsMobileDevice,
  getPlatform,
  getSystemLanguage,
} from 'core/common/store/system/selectors';
import { formatDateByLocale } from 'core/common/utils/date';
import { getFormattedCity } from 'core/common/utils/getFormattedCity';
import { config } from 'core/config';
import { getFeatures } from 'core/feature-flags/store/selectors';
import { getHumanDesignReport } from 'core/human-design/store/selectors';
import {
  getMoonPhase,
  getMoonSign,
  getPartnerMoonPhase,
  getPartnerMoonSign,
} from 'core/moon-compatibility/store/selectors';
import { getNatalChartData, getNatalChartSignsInfo } from 'core/natal-chart/store/selectors';
import { getPaymentCardBank, getPaymentCardBrand } from 'core/payments/store/selectors';
import {
  getUserInformation,
  getUserLocation,
  getUtmAdName,
  getUtmContent,
  getUtmCookies,
  getUtmCreoGroup,
  getUtmSource,
} from 'core/user/store/selectors';

export const getBaseConditionAttributes = createSelector(
  [
    getUtmSource,
    getUtmContent,
    getUtmAdName,
    getUtmCreoGroup,
    getUserInformation,
    getSystemLanguage,
    getMoonPhase,
    getMoonSign,
    getPartnerMoonPhase,
    getPartnerMoonSign,
    getHumanDesignReport,
    getIsAppleMobile,
    getIsMobileDevice,
    getPlatform,
    getUserLocation,
    getUtmCookies,
    getFeatures,
    getNatalChartSignsInfo,
    getNatalChartData,
    getPaymentCardBank,
    getPaymentCardBrand,
  ],
  (
    utmSource,
    utmContent,
    utmAdName,
    utmCreoGroup,
    userProfile,
    language,
    moonPhase,
    moonSign,
    partnerMoonPhase,
    partnerMoonSign,
    humanDesignReport,
    isAppleMobile,
    isMobileDevice,
    platform,
    userLocation,
    utmCookies,
    features,
    natalChartSignsInfo,
    natalChartData,
    paymentCardBank,
    paymentCardBrand,
  ) => {
    return {
      techLinks: config.techLinks,
      language,
      utmSource,
      utmContent,
      utmAdName,
      utmCreoGroup,
      utmCookies,
      isAppleMobile,
      isMobileDevice,
      locationLocale: userLocation.locale,
      locationRegion: userLocation.region,
      moonPhase,
      moonSign,
      partnerMoonPhase,
      partnerMoonSign,
      humanDesignReport: humanDesignReport?.chartData ?? {},
      platform,
      natalChartSignsInfo,
      natalChartHouses: natalChartData.planetsInHouse,
      formattedLocation: getFormattedCity(userProfile.location),
      formattedDate: formatDateByLocale(userProfile.date, language),
      ...features,
      ...userProfile,
      localizeOffers: true,
      paymentCardBank,
      paymentCardBrand,
    };
  },
);

export type BaseConditionAttributes = ReturnType<typeof getBaseConditionAttributes>;
